import React, { useState, useLayoutEffect } from 'react'

import i18n from 'live/services/i18n'
import SaveButton from 'live/components/forms/ui/button-save'
import {Button} from 'react-bootstrap'
import { UpdateEnvPropertiesContainer, UpdateEnvPropertiesSaveBar } from './styles'
import {listEnvProperties, putEnvProperties} from '../../../services/envProperties'
import globalNotification from 'live/services/global-notification'

interface IEnvVar {
    key: string
    value: string
    canEditKey: boolean
}

export const UpdateEnvProperties: React.FC = () => {
    const [edit, setEdit] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    // const [envProperties, setEnvProperties] = useState<unknown>()
    const [envVarRow,setEnvVarRow]=useState<IEnvVar[]>([])
    const [dataToRequisition, setDataToRequisition] = useState<unknown>([{}])

    const handleEditMode = (): void => {
        setEdit(!edit)
    }

    const handleAddRow=()=>{
        envVarRow.push({key: null, value: null, canEditKey: true})
        setEnvVarRow([...envVarRow])
    }

    const handleDeleteRow=(index: number)=>{
        envVarRow.splice(index, 1)
        setEnvVarRow([...envVarRow])
    }
 
    const handleChangeValue=(index: number, onChangeValue: React.ChangeEvent<HTMLInputElement>)=>{
        envVarRow[index].value = onChangeValue.target.value
        setEnvVarRow([...envVarRow])
    }

    const handleChangeKey=(index: number, onChangeValue: React.ChangeEvent<HTMLInputElement>)=>{
        envVarRow[index].key = onChangeValue.target.value
        setEnvVarRow([...envVarRow])
    }

    const getProperties = async (): Promise<void> => {
        try {
            setLoading(true)
            const data = await listEnvProperties()
            const entries = Object.entries(data)
            const newArr = []
            
            entries.forEach(ent => {
                const blankObject: IEnvVar = {key: ent[0], value: ent[1], canEditKey: false}
                newArr.push(blankObject)
            })
            setEnvVarRow(newArr)

        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list environment properties.'))
        } finally {
            setLoading(false)
        }
    }

    const putProperties = async (): Promise<void> => {
        try {
            setLoading(true)
            const objectToSend = {}
            envVarRow.forEach(obj => {
                objectToSend[obj.key] = obj.value
            })
            const data = await putEnvProperties(objectToSend)
            handleEditMode()
            globalNotification.success(i18n('Environment properties have been saved.'))
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list environment properties.'))
        } finally {
            setLoading(false)
        }
    }

    useLayoutEffect(() => {
        getProperties()
    }, [edit])

    return (
        <UpdateEnvPropertiesContainer className="env-properties-container" editMode={edit}>
            <div className="title">
                <span>{i18n('Choose an environment property for your LIVE applications')}</span>
                {!edit &&
                    <button onClick={handleEditMode} id="edit-mode-button">
                        <i className="far fa-edit"></i>
                    </button>
                }
            </div>
            <div className="header">
                <div>{i18n('PROPERTY NAME')}</div>
                <div>{i18n('PROPERTY VALUE')}</div>
            </div>
                {envVarRow.map((data,i)=>{
                    return(
                        <div className="generated-input">
                            <input readOnly={!edit} placeholder={i18n('Property name')} id="input-key" className="inputKey" value={data.key} onChange={e=>handleChangeKey(i, e)} />
                            <input readOnly={!edit} placeholder={i18n('Property value')} id="input-value" className="inputValue" value={data.value} onChange={e=>handleChangeValue(i, e)} />
                            {edit && 
                                <button id="delete-item" className="delete" onClick={() => handleDeleteRow(i)}>
                                    <i className="far fa-trash-alt"></i>
                                </button>
                            }
                        </div>
                    )
                })}
                {edit && 
                    <>
                        <button id="new-row" className="newVariable" onClick={handleAddRow}>
                            <i className="far fa-plus"></i> {i18n('New property')}
                        </button>
                        <UpdateEnvPropertiesSaveBar>
                            <SaveButton
                                className="btn-lg btn-bold save"
                                iconSaveButton={false}
                                type="submit"
                                id="env-properties-save-button"
                                onClick={putProperties}
                            />
                            <Button id="cancel-button" className="btn-lg btn-bold cancel" type="button" onClick={handleEditMode}>
                                {i18n('Cancel')}
                            </Button>
                        </UpdateEnvPropertiesSaveBar>
                    </>
                }
        </UpdateEnvPropertiesContainer>
    )
}
